import React from 'react'
import {
  Box,
  Flex,
  HStack,
  Link,
  Icon,
  Text,
  useColorModeValue,
} from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import {
  FaYoutube,
  FaSpotify,
  FaInstagram,
  FaTiktok,
  FaFacebook,
} from 'react-icons/fa'

import { LinkedinIcon } from '@/components/icons/LinkedinIcon'
import { XIcon } from '@/components/icons/XIcon'

export const Follow = () => {
  const t = useTranslations()

  return (
    <Flex alignItems={{ base: 'center', lg: 'flex-start' }} direction="column">
      <Box mb="12px !important">
        <Text
          m="0 !important"
          fontSize="sm !important"
          fontWeight="bold !important"
          textTransform="uppercase"
          color={useColorModeValue('black', 'white')}
        >
          {t('common.follow')}
        </Text>
      </Box>
      <HStack gap={4} alignItems={'flex-start'}>
        <Link
          href="https://x.com/Compass_Mining"
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
        >
          <XIcon
            mt={1}
            h="6"
            w="6"
            color={useColorModeValue('black', 'white')}
          />
        </Link>
        <Link
          href="https://www.linkedin.com/company/compassmining"
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
        >
          <LinkedinIcon
            mt={1}
            h="6"
            w="6"
            color={useColorModeValue('black', 'white')}
          />
        </Link>
        <Link
          href="https://www.facebook.com/realcompassmining"
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
        >
          <Icon
            as={FaFacebook}
            w="8"
            h="8"
            color={useColorModeValue('black', 'white')}
          />
        </Link>
        <Link
          href="https://www.instagram.com/realcompassmining/"
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
        >
          <Icon
            as={FaInstagram}
            w="8"
            h="8"
            color={useColorModeValue('black', 'white')}
          />
        </Link>
        <Link
          href="https://open.spotify.com/show/36XWVmiCjUwVq5grF8i041"
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
        >
          <Icon
            as={FaSpotify}
            w="8"
            h="8"
            color={useColorModeValue('black', 'white')}
          />
        </Link>
        <Link
          href="https://www.tiktok.com/@compassmining"
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
        >
          <Icon
            as={FaTiktok}
            w="8"
            h="8"
            color={useColorModeValue('black', 'white')}
          />
        </Link>
        <Link
          href="https://www.youtube.com/@CompassMining"
          isExternal
          _hover={{ transform: 'scale(1.2)', transition: '0.3s ease-in-out' }}
        >
          <Icon
            as={FaYoutube}
            w="8"
            h="8"
            color={useColorModeValue('black', 'white')}
          />
        </Link>
      </HStack>
    </Flex>
  )
}
